import { MenuItem } from "@mui/material"
import { Fragment, useState } from "react"
import axios from "axios"
import { useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { mapbox_to_geojson } from "../../utils/layer_actions"
import HandleFail from "../../utils/error_handler"

const move_point = (
  map_ref,
  dispatch_map_data,
  clicked_feature_id,
  source_id,
) => {
  const commit = (e) => {
    map_ref.off("mousemove", move)
    if (source_id === "source_facilities") {
      dispatch_map_data({
        type: "UPDATE_FACILITY_LOCATION",
        payload: {
          coords: [e.lngLat.lng, e.lngLat.lat],
          id: clicked_feature_id,
        },
      })
    } else if (source_id === "source_cups") {
      dispatch_map_data({
        type: "UPDATE_CUP_LOCATION",
        payload: {
          coords: [e.lngLat.lng, e.lngLat.lat],
          id: clicked_feature_id,
        },
      })
    }
  }
  const move = (e) => {
    const source = map_ref.getSource(source_id)
    point.geometry.coordinates = [e.lngLat.lng, e.lngLat.lat]
    source.updateData(point)
  }
  const features = map_ref.querySourceFeatures(source_id)
  let point = features.find((feature) => feature.id === clicked_feature_id)
  map_ref.on("mousemove", move)
  map_ref.once("click", commit)
}

const default_facility_properties = {
  name: "New",
  capacity: 200000,
  fixed: false,
  type: "public_expansion",
}

const default_cup_properties = { name: "New", fixed: false }

const MainMenu = ({
  dispatch_map_data,
  dispatch_ui,
  clicked_feature,
  handle_close_menu,
  map_ref,
  menu_position,
  set_distance_query,
  set_measure_mode,
  set_mode,
}) => {
  const feature_type = clicked_feature?.layer.id

  return (
    <Fragment>
      {["facilities", "cups", "district_municipalities"].includes(
        feature_type,
      ) ? (
        <MenuOption
          label="View"
          on_click={() => {
            if (feature_type === "cups") {
              dispatch_ui({
                type: "SET_VIEW_CUP",
                payload: { id: clicked_feature.id },
              })
            }
            if (feature_type === "facilities") {
              dispatch_ui({
                type: "SET_VIEW_FACILITY",
                payload: { id: clicked_feature.id },
              })
            }
            if (feature_type === "district_municipalities") {
              dispatch_ui({
                type: "SET_VIEW_DISTRICT",
                payload: { id: clicked_feature.id },
              })
            }
            handle_close_menu()
          }}
        />
      ) : null}

      {["facilities", "cups"].includes(feature_type) ? (
        <Fragment>
          <MenuOption
            label="Edit"
            on_click={() => {
              if (feature_type === "facilities") {
                dispatch_ui({
                  type: "SET_EDIT_FACILITY",
                  payload: { feature: clicked_feature },
                })
              } else if (feature_type === "cups") {
                dispatch_ui({
                  type: "SET_EDIT_CUP",
                  payload: { feature: clicked_feature },
                })
              }
              handle_close_menu()
            }}
          />
        </Fragment>
      ) : null}

      {["facilities", "cups"].includes(feature_type) ? (
        <Fragment>
          <MenuOption
            label="Delete"
            on_click={() => {
              if (feature_type === "facilities") {
                const { id } = clicked_feature
                dispatch_map_data({ type: "DELETE_FACILITY", payload: { id } })
                dispatch_ui({
                  type: "SET_VIEW_FACILITY",
                  payload: { id: null },
                })
              } else if (feature_type === "cups") {
                const { id } = clicked_feature
                dispatch_map_data({ type: "DELETE_CUP", payload: { id } })
                dispatch_ui({
                  type: "SET_VIEW_CUP",
                  payload: { id: null },
                })
              }
              handle_close_menu()
            }}
            font_color={"red"}
          />
          <MenuOption
            label="Move"
            on_click={() => {
              handle_close_menu()
              if (feature_type === "facilities") {
                move_point(
                  map_ref,
                  dispatch_map_data,
                  clicked_feature.id,
                  "source_facilities",
                )
              }
              if (feature_type === "cups") {
                move_point(
                  map_ref,
                  dispatch_map_data,
                  clicked_feature.id,
                  "source_cups",
                )
              }
            }}
          />
        </Fragment>
      ) : null}

      {["analysis_units_catchment", "analysis_units_shaded"].includes(
        feature_type,
      ) ? (
        <Fragment>
          <MenuOption
            label="New facility"
            on_click={() => {
              dispatch_map_data({
                type: "CREATE_FACILITY",
                payload: {
                  coords: menu_position.lngLat,
                  properties: default_facility_properties,
                },
              })
              handle_close_menu()
            }}
          />
          <MenuOption
            label="New CUP"
            on_click={() => {
              dispatch_map_data({
                type: "CREATE_CUP",
                payload: {
                  coords: menu_position.lngLat,
                  properties: default_cup_properties,
                },
              })
              handle_close_menu()
            }}
          />
          <MenuOption
            label="Distance"
            on_click={() => {
              set_distance_query({
                last_updated: null,
                from: null,
                to: null,
                distance: null,
              })
              set_measure_mode(true)
              handle_close_menu()
            }}
          />

          <MenuOption
            label="Reassign Ward"
            on_click={() => {
              set_mode("reassign_ward")
            }}
          />
        </Fragment>
      ) : null}

      {["cups"].includes(feature_type) ? (
        <Fragment>
          <MenuOption
            label="Save Edit"
            on_click={() => {
              set_mode("change_request")
            }}
          />
        </Fragment>
      ) : null}
    </Fragment>
  )
}

function MenuOption(props) {
  const { label, on_click, font_color } = props
  return (
    <div
      style={{
        padding: "3px 8px",
        cursor: "pointer",
        color: font_color ? font_color : "",
      }}
      onClick={on_click}
    >
      {label}
    </div>
  )
}

const AssignWardMenu = ({
  handle_close_menu,
  set_mode,
  clicked_feature,
  map_data,
  dispatch_map_data,
}) => {
  const { cup_geo_json } = map_data
  if (!cup_geo_json || !clicked_feature) {
    return null
  }

  const { ward_id } = clicked_feature.properties

  const handle_click = (ward_id, cup_id) => {
    dispatch_map_data({
      type: "ASSIGN_WARD_TO_CUP",
      payload: { ward_id, cup_id },
    })
    set_mode("main")
    handle_close_menu()
  }

  const options = cup_geo_json.features.map(({ properties: { name }, id }) => ({
    id,
    name,
  }))
  options.unshift({ id: null, name: "None" })

  return options.map(({ id, name }) => (
    <MenuItem
      key={id}
      onClick={() => {
        handle_click(ward_id, id)
      }}
    >
      {name}
    </MenuItem>
  ))
}

const ChangeRequestMenu = ({
  feature,
  set_change_requests,
  set_mode,
  handle_close_menu,
  au_geo_json,
}) => {
  const { session_id } = useParams()
  const { server_id } = feature.properties

  return (
    <Fragment>
      <MenuItem
        onClick={async () => {
          HandleFail(async () => {
            const au_ids = au_geo_json.features
              .filter((au) => au.properties.cup_id === feature.id)
              .map((feature) => feature.id)
            const {
              properties: { server_id },
            } = feature
            const type = server_id ? "edit" : "create"

            if (
              (type === "edit" || type === "create") &&
              (!feature.properties.name ||
                ["NEW", "HYPOTHETICAL"].some((kw) =>
                  feature.properties.name.toUpperCase().includes(kw),
                ))
            ) {
              throw new Error(
                "Please provide a better name for the CUP before submitting a change request.",
              )
            }

            const { data } = await axios.post("/api/change_request", {
              entity_id: server_id,
              entity_type: "cup",
              type,
              session_id,
              data: { feature: mapbox_to_geojson(feature), au_ids },
            })
            set_change_requests((change_requests) => [...change_requests, data])
            toast.success("Change request created")
            set_mode("main")
            handle_close_menu()
          })
        }}
      >
        {server_id ? "Update" : "Create"}
      </MenuItem>
      {server_id !== undefined && server_id !== null ? (
        <MenuItem
          onClick={async () => {
            HandleFail(async () => {
              const { data } = await axios.post("/api/change_request", {
                entity_id: server_id,
                entity_type: "cup",
                type: "delete",
                session_id,
                data: { feature: mapbox_to_geojson(feature) },
              })
              set_change_requests((change_requests) => [
                ...change_requests,
                data,
              ])
              set_mode("main")
              handle_close_menu()
              toast.success("Change request created")
            })
          }}
        >
          Delete
        </MenuItem>
      ) : null}
    </Fragment>
  )
}

export default function RightClickMenu({
  dispatch_ui,
  menu_position,
  menu_ref,
  clicked_feature,
  handle_close_menu,
  map_ref,
  set_distance_query,
  set_measure_mode,
  set_change_requests,
  map_data,
  dispatch_map_data,
}) {
  const [mode, set_mode] = useState("main")

  if (!clicked_feature) {
    return null
  }

  return (
    <Fragment>
      <div
        style={{
          position: "absolute",
          top: menu_position.y,
          left: menu_position.x,
          backgroundColor: "white",
          border: "1px solid #ccc",
          borderRadius: "5px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          padding: "4px",
          maxHeight: 300,
          overflow: "auto",
          zIndex: 1000,
        }}
        ref={menu_ref}
      >
        {mode === "main" ? (
          <MainMenu
            dispatch_map_data={dispatch_map_data}
            clicked_feature={clicked_feature}
            handle_close_menu={handle_close_menu}
            dispatch_ui={dispatch_ui}
            map_ref={map_ref}
            menu_position={menu_position}
            set_distance_query={set_distance_query}
            set_measure_mode={set_measure_mode}
            set_mode={set_mode}
            set_change_requests={set_change_requests}
          />
        ) : null}

        {mode === "reassign_ward" ? (
          <AssignWardMenu
            map_data={map_data}
            handle_close_menu={handle_close_menu}
            set_mode={set_mode}
            clicked_feature={clicked_feature}
            set_change_requests={set_change_requests}
            dispatch_map_data={dispatch_map_data}
          />
        ) : null}

        {mode === "change_request" ? (
          <ChangeRequestMenu
            feature={clicked_feature}
            set_change_requests={set_change_requests}
            set_mode={set_mode}
            handle_close_menu={handle_close_menu}
            au_geo_json={map_data.au_geo_json}
          />
        ) : null}
      </div>
    </Fragment>
  )
}
